export default "__VITE_ASSET__CkGTP87t__"